import { render, staticRenderFns } from "./SalesOrderViewLogs.vue?vue&type=template&id=3cbbe49a"
import script from "./SalesOrderViewLogs.vue?vue&type=script&lang=js"
export * from "./SalesOrderViewLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports